import { z } from 'zod';
import { INBOX_SOURCES, type InboxSource } from './inbox';

/* ─────────── Личный календарь и подписка (раздел 6.21: ЗД-05, ЗД-11, ЗД-12) ─────────── */

const DateStr = z.iso.date();

/** Откуда событие в календаре */
export const CALENDAR_KINDS = {
  /** Дело из «Ждёт меня» со сроком: согласование, платёж, проверка, поручение мне */
  inbox: 'Дело со сроком',
  /** Поручение, которое я выдал: контроль срока */
  control: 'Контроль поручения',
  /** Веха проекта */
  milestone: 'Веха проекта',
  /** Плановый платёж или поставка по графику договора */
  contract: 'График договора',
} as const;
export type CalendarKind = keyof typeof CALENDAR_KINDS;

export const CalendarEvent = z.object({
  id: z.string(),
  /** День события (ISO); события календаря портала — на день, без времени */
  date: DateStr,
  title: z.string(),
  details: z.string().nullable(),
  kind: z.enum(Object.keys(CALENDAR_KINDS) as [CalendarKind, ...CalendarKind[]]),
  /** Раздел-источник для дел из «Ждёт меня» */
  source: z.enum(Object.keys(INBOX_SOURCES) as [InboxSource, ...InboxSource[]]).nullable(),
  projectId: z.uuid().nullable(),
  projectCode: z.string().nullable(),
  /** Срок прошёл, а дело не закрыто */
  overdue: z.boolean(),
  /** Событие уже состоялось или закрыто (веха с фактической датой, выполненная строка графика) */
  done: z.boolean(),
  /** Куда ведёт событие в портале */
  path: z.string(),
});
export type CalendarEvent = z.infer<typeof CalendarEvent>;

export const CalendarQuery = z.object({
  from: DateStr,
  to: DateStr,
  projectId: z.uuid().optional(),
});
export type CalendarQuery = z.infer<typeof CalendarQuery>;

/** Подписка на календарь по закрытой ссылке (ЗД-12): ссылка показывается один раз при выпуске */
export const CalendarFeedState = z.object({
  /** Подписка выпущена и действует */
  active: z.boolean(),
  createdAt: z.string().nullable(),
  /** Когда календарь телефона в последний раз забирал ленту */
  lastFetchedAt: z.string().nullable(),
});
export type CalendarFeedState = z.infer<typeof CalendarFeedState>;

export const CalendarFeedIssued = CalendarFeedState.extend({
  /** Полная ссылка на ленту .ics — только в ответе на выпуск; дальше хранится лишь её отпечаток */
  url: z.string(),
});
export type CalendarFeedIssued = z.infer<typeof CalendarFeedIssued>;
